import { useParams } from 'react-router-dom';
import { useGet } from '../lib/api/hooks';
import { CaseDetailsModel } from '../lib/models/CaseDetailsModel';
import BlueRibbon from '../components/CaseDetails/BlueRibbon';
// import useTrackPageView from '../lib/hooks/use-track-page-view';
// import useTrackException from '../lib/hooks/use-track-exception';
// import useTrackEvent from '../lib/hooks/use-track-event';
import { useCallback, useEffect, useMemo, useState } from 'react';
import CaseDetailsHeader from '../components/CaseDetails/CaseDetailsHeader';
import CaseDetailsGeneralInfo from '../components/CaseDetails/CaseDetailsGeneralInfo';
import ClinicalReviewActivityListing from '../components/CaseDetails/ClinicalActivity/ClinicalReviewActivityListing';
import { ClinicalReviewActivityModel } from '../lib/models/ClinicalReviewActivityModel';
import CaseMessages from '../components/CaseDetails/CaseMessages/CaseMessages';
import { Backdrop, CircularProgress } from '@mui/material';
import { backdropStyle } from '../style';
import AuditHistory from '../components/Audit/AuditHistory';
import { AuditHistoryModel } from '../lib/models/AuditHistoryModel';
import { CaseMessageModel } from '../lib/models/CaseMessageModel';
import { navMenuService } from '../lib/constants/nav-menu-data';
import useIsUserRole from '../lib/hooks/use-is-user-role';

export function AuditCaseDetailsPage() {
    //TODO: Consider tracking the events properly for the Audit cases
    // const trackPageView = useTrackPageView();
    // const trackEvent = useTrackEvent();
    // const trackException = useTrackException();
    const { id, crmClient, isCosign } = useParams();
    const { data, loading } = useGet<CaseDetailsModel>(
        `casedetails\\getcasedetails?caseId=${id}&crmId=${crmClient}&isAuditable=${false}`
    );
    const [auditHistory, setAuditHistory] = useState<AuditHistoryModel[]>();
    const [caseMessages, setCaseMessages] = useState<CaseMessageModel[]>();

    const allowedRolesForAudit = useMemo(() => {
        const roles = navMenuService.getRolesOfNavItem('/search');
        return roles?.filter((r) => r !== 'user') || [];
    }, []);

    const isRoleAllowed = useIsUserRole(...allowedRolesForAudit);

    const onCaseMessagesData = useCallback((caseMessagesData: CaseMessageModel[]) => {
        setCaseMessages(caseMessagesData);
    }, []);

    const onAuditHistoryData = useCallback((auditHistoryData: AuditHistoryModel[]) => {
        setAuditHistory(auditHistoryData);
    }, []);

    //Clinical Reviews
    const [clinicalReviews, setClinicalReviews] = useState<
        ClinicalReviewActivityModel[] | undefined
    >(data?.clinicalReviews);

    useEffect(() => {
        setClinicalReviews(data?.clinicalReviews);
    }, [loading, data?.clinicalReviews]);

    return (
        <>
            {!loading ? (
                <>
                    <CaseDetailsHeader
                        caseNumber={data?.caseNumber}
                        displayDueDate={data?.displayDueDate}
                        displayDueTime={data?.displayDueTime}
                        id={data?.crmCaseId}
                        caseDetails={data}
                        crmClient={crmClient}
                        auditHistory={auditHistory}
                        caseMessages={caseMessages}
                        isAudit
                        clinicalReviewId={data?.caseId}
                    />
                    {data != null ? (
                        <>
                            {/* TODO: Link the doctor, dateTime and timeTaken props */}
                            <BlueRibbon
                                title={'Audit'}
                                appealedCodeNumber={0}
                                doctor={data.userName}
                                dateTime={data.submittedDate}
                                timeTaken={data.minutesTaken}
                            />

                            <CaseDetailsGeneralInfo
                                data={data}
                                isReadOnly={true}
                                isDialogOpen={false}
                            />

                            {isRoleAllowed && (
                                <AuditHistory
                                    clinicalReviewId={data?.caseId}
                                    isCosign={isCosign}
                                    onApiData={onAuditHistoryData}
                                />
                            )}

                            <ClinicalReviewActivityListing clinicalReviews={clinicalReviews} />

                            <CaseMessages
                                caseId={data.crmCaseId}
                                crmClient={data.crmClientName}
                                userId={data.userId}
                                caseStage={data.caseStage}
                                isReadonly
                                onApiData={onCaseMessagesData}
                            />
                        </>
                    ) : null}
                </>
            ) : (
                <>
                    <Backdrop sx={backdropStyle} open={loading}>
                        <CircularProgress color="inherit" />
                    </Backdrop>
                </>
            )}
        </>
    );
}
